export enum ApplicationType {
  PowerBIService = 1,
  PowerBIServer = 2,
}
